import { request } from "./utils";

export const loginServices = {
  sendLoginEmail,
};

export interface IToken {
  access_expiration: string;
  access_token: string;
  token_type: string;
}

export interface IFailedRequest {
  code?: string;
  message: string;
}

export interface IValidateData {
  is_valid: boolean;
}

export interface IVerifyEmailData {
  email: string;
  code: string;
}

/**
 * Sends a login email to the user's email
 *
 * @param {string} email data
 */
async function sendLoginEmail(email: string): Promise<IToken> {
  const requestOptions: RequestInit = {
    method: "POST",
    body: JSON.stringify({
      email,
    }),
  };
  const data = await request("/admin/stripe/login", requestOptions, false);

  if (data instanceof Error) {
    const error: IFailedRequest = JSON.parse(data.message);
    return Promise.reject(error);
  }

  return data;
}
